import { ReassuranceCarouselProps } from './ReassuranceCarousel';

export const parseReassuranceCarouselData = (
  contentfulSection: any,
): ReassuranceCarouselProps | null => {
  const { subsections } = contentfulSection;

  const carouselItems = subsections.map((item: any, index: number) => ({
    id: index,
    text: item.displayName,
    iconName: item.metadata?.context?.highlight_carousel_item?.icon,
    iconColor:
      item.metadata?.context?.highlight_carousel_item?.color || 'viridian.base',
  }));

  const reassuranceCarouselData = {
    carouselItems: carouselItems,
    isAnimated: contentfulSection.metadata?.flags[0]?.value,
  };

  return reassuranceCarouselData;
};
